"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var handleEvent_1 = require("../assets/handleEvent");

var Hr_1 = __importDefault(require("../Hr/Hr"));

var i18n_1 = require("../utils/i18n");

var dateUtils_1 = require("./dateUtils");

var DatePickerBody_1 = __importDefault(require("./markup/DatePickerBody"));

var DatePickerContainer_1 = __importDefault(require("./markup/DatePickerContainer"));

var DatePickerDay_1 = __importDefault(require("./markup/DatePickerDay"));

var DatePickerHead_1 = __importDefault(require("./markup/DatePickerHead"));

var DatePickerWeek_1 = __importDefault(require("./markup/DatePickerWeek"));

var DatePicker =
/** @class */
function (_super) {
  __extends(DatePicker, _super);

  function DatePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      pageMoment: _this.initialMoment
    };

    _this.getMax = function (a, b) {
      return new Date(a > b ? a : b);
    };

    _this.getMin = function (a, b) {
      return new Date(a < b ? a : b);
    };

    _this.getDateFormat = function (pageMoment) {
      var options = {
        month: 'long',
        year: 'numeric'
      };
      return i18n_1.intlConfig.formatDate(pageMoment, options).replace('г.', '');
    };

    _this.compare = function (prepareDate) {
      return function (a, b, comparator) {
        a = new Date(a);
        b = new Date(b);
        prepareDate(a);
        prepareDate(b);
        return comparator(a, b);
      };
    };

    _this.compareMonth = _this.compare(function (a) {
      a.setDate(1);
      a.setHours(0, 0, 0, 0);
    });
    _this.compareDay = _this.compare(function (a) {
      a.setHours(0, 0, 0, 0);
    });
    return _this;
  }

  Object.defineProperty(DatePicker.prototype, "initialMoment", {
    get: function get() {
      var selectedMoment = this.selectedMoment;

      if (selectedMoment) {
        return selectedMoment;
      }

      return new Date();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "selectedMoment", {
    get: function get() {
      var value = this.props.value;
      return value ? value : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "max", {
    get: function get() {
      var max = this.props.max;
      return max ? max : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "min", {
    get: function get() {
      var min = this.props.min;
      return min ? min : null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "pageMoment", {
    get: function get() {
      return new Date(this.state.pageMoment);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "head", {
    get: function get() {
      var _this = this;

      var _a = this,
          pageMoment = _a.pageMoment,
          max = _a.max,
          min = _a.min;

      var nextMonth = new Date(pageMoment);
      nextMonth.setMonth(pageMoment.getMonth() + 1);
      var prevMonth = new Date(pageMoment);
      prevMonth.setMonth(pageMoment.getMonth() - 1);

      var onPrev = function onPrev() {
        return _this.setState({
          pageMoment: prevMonth
        });
      };

      var onNext = function onNext() {
        return _this.setState({
          pageMoment: nextMonth
        });
      };

      var disabledNext = max && this.compareMonth(max, nextMonth, function (a, b) {
        return a < b;
      });
      var disabledPrev = min && this.compareMonth(min, prevMonth, function (a, b) {
        return a > b;
      });
      return react_1.default.createElement(DatePickerHead_1.default, {
        onPrev: onPrev,
        onNext: onNext,
        disabledNext: disabledNext,
        disabledPrev: disabledPrev
      }, this.getDateFormat(pageMoment));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "body", {
    get: function get() {
      return react_1.default.createElement(DatePickerBody_1.default, null, this.renderWeeks());
    },
    enumerable: false,
    configurable: true
  });

  DatePicker.prototype.UNSAFE_componentWillReceiveProps = function (_a) {
    var value = _a.value;

    if (!value) {
      return;
    }

    var selectedMoment = value;

    if (selectedMoment && this.pageMoment.getMonth() === selectedMoment.getMonth()) {
      return;
    }

    this.setState({
      pageMoment: selectedMoment
    });
  };

  DatePicker.prototype.onDayClick = function (day) {
    var _this = this;

    var _a = this,
        min = _a.min,
        max = _a.max;

    if (min) {
      day = this.getMax(min, day);
    }

    if (max) {
      day = this.getMin(max, day);
    }

    return function () {
      return handleEvent_1.handleEvent(_this.props.onChange, day);
    };
  };

  DatePicker.prototype.renderWeeks = function () {
    var result = [];
    var pageMoment = this.pageMoment;

    for (var _i = 0, _a = dateUtils_1.generateWeeks(pageMoment); _i < _a.length; _i++) {
      var week = _a[_i];
      result.push(react_1.default.createElement(DatePickerWeek_1.default, {
        key: result.length
      }, this.renderDays(week)));
    }

    return result;
  };

  DatePicker.prototype.renderDays = function (week) {
    var _this = this;

    var _a = this,
        pageMoment = _a.pageMoment,
        max = _a.max,
        min = _a.min,
        selectedMoment = _a.selectedMoment;

    var now = new Date();
    var month = pageMoment.getMonth();
    return week.map(function (date, index) {
      var isToday = now.toDateString() === date.toDateString();

      var disabled = max && _this.compareDay(date, max, function (a, b) {
        return a > b;
      }) || min && _this.compareDay(date, min, function (a, b) {
        return a < b;
      });

      var selected = selectedMoment && date.toDateString() === selectedMoment.toDateString();
      var text = i18n_1.intlConfig.formatDate(date, {
        day: 'numeric'
      });
      var secondary = month !== date.getMonth();
      var testId = "date-" + date.toLocaleDateString();
      return react_1.default.createElement(DatePickerDay_1.default, {
        testId: testId,
        disabled: disabled,
        onClick: _this.onDayClick(date),
        selected: selected,
        primary: isToday,
        secondary: secondary,
        key: index
      }, text);
    });
  };

  DatePicker.prototype.render = function () {
    var _a = this,
        head = _a.head,
        body = _a.body;

    return react_1.default.createElement(DatePickerContainer_1.default, __assign({}, this.props), head, react_1.default.createElement(Hr_1.default, {
      oversize: false
    }), body);
  };

  return DatePicker;
}(react_1.default.Component);

exports.default = DatePicker;